/** Date helpers. App is IST (Asia/Kolkata). Backend stores attendance.date as IST. */
export function todayIST() {
  // Convert "now" into IST and produce YYYY-MM-DD.
  // Using the offset trick avoids any Intl edge cases on older browsers.
  const now = new Date();
  const istMs = now.getTime() + (now.getTimezoneOffset() + 330) * 60 * 1000;
  const ist = new Date(istMs);
  const y = ist.getFullYear();
  const m = String(ist.getMonth() + 1).padStart(2, "0");
  const d = String(ist.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Convert an ISO datetime string (UTC) to IST clock time.
 *  fmt = "short" -> HH:MM   |   "full" -> HH:MM:SS   |   "datetime" -> DD/MM HH:MM
 */
export function formatIST(iso, fmt = "full") {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const istMs = d.getTime() + (d.getTimezoneOffset() + 330) * 60 * 1000;
  const ist = new Date(istMs);
  const hh = String(ist.getHours()).padStart(2, "0");
  const mm = String(ist.getMinutes()).padStart(2, "0");
  const ss = String(ist.getSeconds()).padStart(2, "0");
  if (fmt === "short") return `${hh}:${mm}`;
  if (fmt === "datetime") {
    const dd = String(ist.getDate()).padStart(2, "0");
    const mo = String(ist.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mo} ${hh}:${mm}`;
  }
  return `${hh}:${mm}:${ss}`;
}
